import { Card, CardContent } from '@lensora/ui'
import { Lock } from 'lucide-react'

interface LookerGateCardProps {
  /** 'flag' = tenant-scope, gated on the looker_studio_enabled feature flag.
   *  'plan' = client-scope self-serve, gated on plan tier. */
  reason: 'flag' | 'plan'
}

export function LookerGateCard({ reason }: LookerGateCardProps) {
  return (
    <Card className="border-feedback-info/30 bg-feedback-info/5">
      <CardContent className="flex items-start gap-3 pt-6">
        <Lock className="mt-0.5 h-5 w-5 shrink-0 text-feedback-info" />
        {reason === 'flag' ? (
          <p className="text-sm text-text">
            The Looker Studio integration isn't enabled for your workspace yet.{' '}
            <a
              href={`mailto:sales@lensora.io?subject=${encodeURIComponent('Enable Looker Studio integration')}`}
              className="text-brand-accent underline"
            >
              Contact sales
            </a>{' '}
            to get it turned on.
          </p>
        ) : (
          <p className="text-sm text-text">
            Exporting data to Looker Studio is available on the Growth and Enterprise plans.{' '}
            <a href="/dashboard/billing" className="text-brand-accent underline">
              Upgrade your plan
            </a>{' '}
            to create Looker Studio keys.
          </p>
        )}
      </CardContent>
    </Card>
  )
}
